import Download from "../Download";

export default ({ url, filename, alt }) => {
  return (
    <>
      <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10 relative">
        {/* <span className="absolute right-2 top-2">
          <Download url={url} name={filename} />
        </span> */}
        <img src={url} alt={alt} />
      </div>
    </>
  );
};
